import { styled, useTheme } from "lib/theme";
import { MdTableRows } from "react-icons/md";

const Wrapper = styled.div`
  padding: 30px;
  background-color: ${({ theme }) => theme.app.colors.white};
  box-shadow: 0px 15px 25px rgba(0, 0, 0, 0.02);
  border-radius: 12px;

  display: flex;
  flex-direction: column;
  align-items: center;
`;

const EmptyTableIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: ${({ theme }) => theme.app.colors.lightGray};
`;

const EmptyTableMessage = styled.div`
  text-align: center;
  h4 {
    font-size: 20px;
    font-weight: 600;
    font-family: ${({ theme }) => theme.app.fontFamily};
    line-height: 1.3;
    margin-top: 20px;
  }
  p {
    font-size: 15px;
    font-family: ${({ theme }) => theme.app.fontFamily};
    color: ${({ theme }) => theme.app.colors.secondaryText};
    margin-top: 15px;
    line-height: 1.5;
  }
`;

export const ZeroState = (props: { title: string; subtitle?: string }) => {
  const theme = useTheme();

  return (
    <Wrapper>
      <EmptyTableIcon>
        <MdTableRows size={40} color={theme.app.colors.gray} />
      </EmptyTableIcon>
      <EmptyTableMessage>
        <h4>{props.title}</h4>
        {props.subtitle && <p>{props.subtitle}</p>}
      </EmptyTableMessage>
    </Wrapper>
  );
};
